var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M12.658 4.75H6.324v7.917h6.334zM14.25 7.916h17.417v14.25H14.25zM22.176 23.75h9.5v9.5h-9.5zM20.574 23.75H6.324v6.333h14.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M6.324 14.25v7.917h6.334V14.25zm5.334 1H7.324v5.917h4.334z",
    clipRule: "evenodd"
  })));
};
export default SvgDashboard;